import type { Country } from 'models/country';
import { fetchJson } from 'utils/fetchJson/fetchJson';

import { API_URL_V3 } from '../../../constants';

export const countries = {
  fetch: ({ locale = 'EN' }) => {
    const path = `${API_URL_V3}/countries?locale=${locale}`;

    return fetchJson<Country[]>(path);
  },
};
